import React, {useEffect, useState} from 'react'
import './AddMoney.scss'
import cogoToast from "cogo-toast";
import WithdrawMoneyFromWalletMutation from "../../mutations/WithdrawMoneyFromWalletMutation";
import CheckKYCCompletionMutation from "../../mutations/CheckKYCCompletionMutation";
import {MDBIcon} from "mdbreact";
import {withRouter} from "react-router-dom";
import {compose} from "redux";
import {connect} from "react-redux";
import {Zoom} from 'react-reveal'
import {assetUrl} from "../../serviceApi";

const card_wallet_shadow = assetUrl+'images/wallet-card-shadow.svg'
const wrong_image = assetUrl+'images/wrong_image.svg'
const card_wallet = assetUrl+'images/card_wallet.svg'
const card_wallet_disable = assetUrl+'images/wallet_withdrawal _disable.png'
const wallet_purse_image = assetUrl+'images/wallet_purse_image.svg'
const arrow_right = assetUrl+'images/arrow_right.svg'

const WithdrawMoney = (props) => {
    const {setActiveModal,wallet_data} = props;
    const [amount,setAmount] = useState(0);
    const [kyc_fillted,setKYCFill] = useState(null);
    // const [accountType,setAccountType] = useState("Bank_Acc");

    useEffect(() => {
        checkKYC();
    },[]);


    const totalWalletBalance = () => {
        let deposit = parseInt(wallet_data.availableDeposit);
        let earnings = parseInt(wallet_data.availableEarnings);
        let grant = parseInt(wallet_data.availableGrantMoney);
        return (deposit + earnings + grant).toFixed(2);
    }

    const handleSubmit = () =>{
        let wallet_total = parseInt(wallet_data.availableDeposit) + parseInt(wallet_data.availableEarnings) + parseInt(wallet_data.availableGrantMoney);
        if(amount === ""){
            cogoToast.error("Please enter valid amount", { position: 'top-center'});
        } else if(amount > wallet_total){
            cogoToast.error("Entered amount is greater than wallet amount", { position: 'top-center'});
        } else if(amount < 1){
            cogoToast.error("Entered amount is less than min amount Rs.1", { position: 'top-center'});
        } else {
            let input = {
                amount:amount
            }
            WithdrawMoneyFromWalletMutation(input,function (response){
                if(response.withdrawWallet !== null){
                    props.setActiveModal("");
	                cogoToast.success(response.withdrawWallet.message?response.withdrawWallet.message:"Withdrawn successfully", { position: 'top-center'});
                }
            },function (err){
                cogoToast.error(err, { position: 'top-center'});
            });
        }
    }



    const checkKYC = () => {
        let variable = {
            userId:props.user_details.user.id
        }
        CheckKYCCompletionMutation(variable,function (response){
            // console.log(response.kycComplete.message)
             if(response.kycComplete.message === true){
                 setKYCFill(true)
             } else {
                 setKYCFill(false);
             }
        },function (err){
            cogoToast.error(err, { position: 'top-center'});
            setKYCFill(false);
        });
    }

    return (
        <div className={"wallet-withdraw-component"}>
            <div className="wallet-cash-banner mx-2">
                <div className="wallet-cash-banner-wrong_text " onClick={()=>setActiveModal("")}>
                    <img src={wrong_image} alt="Italian Trulli" className="wallet-cash-banner-wrong_icon"/>
                </div>
            </div>
            <div className="wallet_cash_card mx-2">
                <div className="text-center">
                    {kyc_fillted === false ?
                        <Zoom delay={500}><img src={card_wallet_disable} style={{width:"122px",height:"67px"}} alt="Italian Trulli"
                                               className="wallet_cash_card-card_image"/></Zoom>
                        :  <Zoom delay={500}><img src={card_wallet} alt="Italian Trulli"
                                                  className="wallet_cash_card-card_image"/></Zoom>

                    }
                </div>
                <div className={'text-center mb-2'}>
                    <Zoom delay={500}><img src={card_wallet_shadow} alt="Italian Trulli" className={"margin-auto"} /></Zoom>
                </div>

                <p className="wallet_cash_card-heading_text text-center my-2">Withdraw Money</p>
            </div>
            <div className="wallet-cash-part mx-2">
                <div className="wallet-cash-part-heading_part d-flex justify-content-between mb-3 ">
                    <div>
                        <p className="wallet-cash-part-wallet_text my-1 mx-2">Wallet Amount</p>
                        <p className="wallet-cash-part-wallet_number my-1 mx-2">
                            ₹ {
                            Object.keys(wallet_data).length > 0 ?
                                wallet_data.balance: 0
                        }
                            {/*<span*/}
                            {/*className="wallet-cash-part-wallet_number_text">.05</span>*/}
                        </p>
                    </div>
                    <img src={wallet_purse_image} alt="Italian Trulli"
                         className="wallet-cash-part-wallet_image"/>
                </div>
            </div>
            {
                kyc_fillted === true &&
                <div className="mx-2 my-2">
                    <form>
                        <div className="d-flex justify-content-between">
                            <label htmlFor="text" className="value_text my-2">Enter Value</label><br/>
                            {/*<div className="d-flex align-items-center">*/}
                            {/*    <p className="comission my-1 mx-1">15% commission</p>*/}
                            {/*    <img src={comission} alt="italian truli" className="comission_image"/>*/}
                            {/*</div>*/}
                        </div>
                        <input type="number" className="number_text my-2"
                               value={amount}
                               onChange={(e) => {
                                   setAmount(e.target.value);
                               }}
                        />
                        {/*<div className="custom-radio-input-section">*/}
                        {/*    <ul>*/}
                        {/*        <li>*/}
                        {/*            <input type="radio" id="f-option" name="selector"*/}
                        {/*                   checked={accountType === "Bank_Acc"}*/}
                        {/*                   onChange={()=>handleRadioInputs("Bank_Acc")}*/}
                        {/*            />*/}
                        {/*            <label htmlFor="f-option">Bank Account</label>*/}
                        {/*            <div className="check"/>*/}
                        {/*        </li>*/}
                        {/*        <li>*/}
                        {/*            <input type="radio" id="s-option" name="selector"*/}
                        {/*                   checked={accountType === "UPI"}*/}
                        {/*                   onChange={()=>handleRadioInputs("UPI")}*/}
                        {/*            />*/}
                        {/*            <label htmlFor="s-option">UPI</label>*/}
                        {/*            <div className="check">*/}
                        {/*                <div className="inside"/>*/}
                        {/*            </div>*/}
                        {/*        </li>*/}
                        {/*    </ul>*/}
                        {/*</div>*/}
                    </form>
                </div>
            }
            {
                kyc_fillted !== true &&
                    <div className={"kyc-failed-content-section text-center"}>
                        <p className={"description"}>Please verify your account to withdraw money</p>
                        <a className={"verify-acc"} onClick={()=>{
                            props.setActiveModal("");
                            props.history.push("/kyc");
                        }}>
                            Verify account
                            <MDBIcon icon="angle-right" className={"mx-2"} />
                        </a>
                    </div>
            }

            <div className="wallet-cash-footer container my-3">
                <button
                    className="wallet-cash-footer-button-class py-2"
                    onClick={handleSubmit}
                    disabled={kyc_fillted === false}
                >
                    Withdraw Money
                    <img src={arrow_right} alt="Italian Trulli" className="wallet-cash-footer-arrow_image mx-2"/>
                </button>

            </div>


        </div>
    )
}

const mapStateToProps = state => ({
    wallet_data: state.WalletReducer.wallet_data
});

export default compose(
    withRouter,
    connect(mapStateToProps)
)(WithdrawMoney);

